import React, { useState, useEffect, useMemo } from "react";

const TvSchedule = ({ data }) => {
  const isCountryGrouped =
    data && typeof data === "object" && !Array.isArray(data);
  const hasData = isCountryGrouped
    ? Object.keys(data).length > 0
    : data?.length > 0;

  const countries = useMemo(() => {
    return isCountryGrouped ? Object.keys(data).sort() : [];
  }, [data, isCountryGrouped]);

  const [selectedCountry, setSelectedCountry] = useState("");

  useEffect(() => {
    if (countries.length > 0 && !selectedCountry) {
      setSelectedCountry(countries[0]);
    }
  }, [countries, selectedCountry]);
  const getChannelsForCountry = () => {
    if (!selectedCountry) return [];
    return data[selectedCountry] || [];
  };

  return (
    <div className="tv_block">
      <div className="leg_head">
        <h2>TV Schedule</h2>
        <div
          className="country_dropdown"
          style={{ marginBottom: "20px", padding: "10px" }}
        >
          <select
            id="country-select"
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
            style={{
              padding: "8px 12px",
              fontSize: "14px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              minWidth: "200px",
            }}
          >
            {countries?.map((country) => (
              <option key={country} value={country}>
                {country}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="global_table striped tv_tbl">
        {isCountryGrouped ? (
          <>
            {selectedCountry ? (
              <div className="country_schedule">
                <table>
                  <thead>
                    <tr>
                      <th>Channel</th>
                      <th>Air Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {getChannelsForCountry().length > 0 ? (
                      getChannelsForCountry().map((channel, index) => (
                        <tr key={`${selectedCountry}-${index}`}>
                          <td>{channel?.channel_name}</td>
                          <td>
                            {channel?.onair_time
                              ? new Date(channel.onair_time).toLocaleString()
                              : ""}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="2">No channels available</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div
                style={{ padding: "20px", textAlign: "center", color: "#666" }}
              >
                Please select a country to view TV channels
              </div>
            )}
          </>
        ) : (
          // Render flat array data (backward compatibility)
          <table>
            <thead>
              <tr>
                <th>Channel</th>
                <th>Air Time</th>
              </tr>
            </thead>
            <tbody>
              {hasData ? (
                data.map((item, index) => (
                  <tr key={index}>
                    <td>{item?.channel?.name || item?.channel_name}</td>
                    <td>
                      {item?.onair_time
                        ? new Date(item.onair_time).toLocaleString()
                        : ""}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2">No schedule available</td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default TvSchedule;
